<template>
  <div class="goods-item">
    <div class="goods-con">
      <div class="img-com" @click="goJdGoodsDetail">
        <img class="img" :src="'http://img13.360buyimg.com/n2/' + itemData.goodsImage" alt="">
        <!--<div class="no-stock-img" v-if="itemData.mapSkusStock.stockStateId===34"></div>-->
      </div>
      <div class="goods-info">
        <div class="goods-title" @click="goJdGoodsDetail">{{ itemData.goodsName }}</div>
        <div class="info-bottom">
          <div class="price-con" @click="goJdGoodsDetail">
            <span class="now-price">￥{{ itemData.unitAmount.toFixed(2) }}</span>
            <span class="old-price"><s>原价:￥{{ itemData.originalPrice.toFixed(2) }}</s></span>
          </div>
          <div class="stepper-con">x{{ itemData.goodsCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getJdGoodsDetail } from '@/api/mall/mallGoods'
import { getShopSkuPrice } from '@/api/mall/mallJD'
export default {
  components: {

  },
  props: {
    itemData2: {
      required: true,
      default: ()=>{
        return {
          mapSkusStock: {
            stockStateId: 33
          }
        }
      }
    },
  },
  data(){
    return {
      itemData: {
        mapSkusStock: {
          stockStateId: 33
        }
      },
    }
  },
  computed:{
    ...mapGetters([

    ])
  },
  watch: {
    itemData2: {
      handler(newData, oldData) {
        // console.log( 'newData',  newData )
        this.itemData = newData
        this.buyNum = newData.productCount
        this.buyNumCanChange=true
        this.skuIdSelected = newData.skuIdSelected
        this.editSkuIdSelected = newData.editSkuIdSelected
      },
      deep:true,
      immediate: true
    },
  },
  created(){

  },
  methods: {
    goodsClick(){
      this.isGoodsClick = true
    },

    goJdGoodsDetail(){
      if(this.cartEditState){return false}
      this.$router.push({name: 'jdGoodsDetail', query: {shopId: this.itemData.shopId, goodsId: this.itemData.goodsId} })
    }
  }
}
</script>

<style lang="less" scoped>
.goods-item{
  display: flex;font-size: 14px;height: 115px;
  .left-con{
    display: inline-flex;justify-content: center;align-items: center;
    width: 39px;height: 100%;
  }
  .goods-con{
    display: flex;flex: 1;
    .img-com{
      width: 109px;height: 100%;position: relative;
      display: inline-flex;justify-content: center;align-items: center;
      .img{width: 85px;height: 85px;}
    }
    .goods-info{
      flex: 1;display: inline-flex;flex-direction: column;
      justify-content: space-between;
      border-bottom: 1px solid #edecec;
      padding: 15px 12px 15px 0;
      .goods-title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        color: rgba(43,43,43,1);
      }
      .info-bottom{
        display: flex;
        .price-con{
          flex: 1;
          .now-price{color: #f74d4d;padding-right: 10px;}
          .old-price{color: #999;font-size: 10px;}
        }
        .stepper-con{
          font-size: 14px;color: #666;
        }
      }
    }
    &.no-stock{
      .no-stock-img{
        position: absolute;width: 100%;height: 100%;z-index: 1;
        background: rgba(255,255,255,.5) url("../../../../../assets/my/shoppingCart/no-stock-img.png") no-repeat 50% 50%;
        background-size: 60px 60px;
      }
      .goods-info{
        .goods-title{color: rgba(43,43,43,.5);}
        .info-bottom{
          .price-con{
            .now-price{color: rgba(247,77,77,.5);}
            .old-price{color: rgba(153,153,153,.5);}
          }
        }
      }
    }
  }


}
</style>